<template>
    <div class="fw-svd">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
            <div class="svd-user">
                <div class="svd-l">
                    <span v-if="dept.levelVal"> V{{dept.levelVal}}</span>
                    <span v-if="!dept.levelVal"> V0</span>
                </div>
              <div class="svd-r">
                  <span class="s">{{dept.deptName}}</span>
                  <span class="z">PLUS: {{dept.plusName==null?'未开通':dept.plusName}}</span>
                  <span class="x">到期时间: {{dept.expireDate}}</span>
              </div>
            </div>
        <div class="svds">
            <p style="font-size: 13px;margin-bottom: 18px">续费管理</p>
            <div class="svd-items">
                <div class="svd-item" v-for="item in list" @click="toKt(item)">
                    <span class="svdname">{{item.svdName}}</span>
                    <span class="svdname" style="color: #ee0a24">¥ <span style="font-size: 20px">{{item.svdPrice}}</span></span>
                    <span class="svdname">{{item.biaoShu}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie,} from "../../utils/auth";

    export default {
        components: {},
        data() {
            return {
                title: '门店续费',
                fwUser: {},
                deptId: '',
                token: '',
                dept:{},
                list:[],
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.deptId=this.$route.query.deptId
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.token = this.fwUser.token
            this.getSvds()
        },
        methods: {
            async getSvds() {
                let data = {
                    deptId:this.deptId
                }
                let res = await this.$get("/fw/getSvds", data)
                this.dept = res.dept
                this.list = res.svds
            },
            toKt(item){
                var that=this
                this.$dialog.confirm({
                    title: '标题',
                    message: '是否续费?',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消'
                }).then(() => {
                    that.zhifu(item)
                }).catch(() => {
                        // on cancel
                });
            },
            async zhifu(item) {
                let data = {
                    svdId: item.id,
                    deptId: this.deptId,
                    token: this.token
                }
                let res = await this.$post('/fw/renewOrder',data)
                console.log(res)
                if (res.code==200){
                    this.params = res
                    if (typeof WeixinJSBridge === 'undefined') {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(this.params), false)
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady(this.params))
                            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady(this.params))
                        }
                    } else {
                        this.onBridgeReady(this.params)
                    }
                }else {
                    this.$notify({
                        message: '支付失败',
                        duration: 1000,
                        background: 'red'
                    });
                }
            },

            onBridgeReady(params) {
                const that = this
                WeixinJSBridge.invoke(
                    'getBrandWCPayRequest',
                    {
                        appId: params.appId, // 公众号名称，由商户传入
                        timeStamp: params.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                        nonceStr: params.nonceStr, // 支付签名随机串，不长于 32 位
                        package: params.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: params.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: params.paySign // 支付签名
                    },
                    function (res) {
                        if (res.err_msg == 'get_brand_wcpay_request:ok') {
                            that.$router.push('/success')
                        }
                        // // 支付过程中用户取消
                        // if (res.err_msg == "get_brand_wcpay_request:cancel") {
                        //   this.$notify({
                        //     message: '取消支付',
                        //     duration: 1000,
                        //     background: 'red'
                        //   });
                        // }
                        if (res.err_msg == 'get_brand_wcpay_request:fail') {
                            that.$notify({
                                message: '支付失败',
                                duration: 1000,
                                background: 'red'
                            });
                        }
                    }
                )
            },

            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-svd {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #FAFAFA;
    }

    .svds{
        padding: 15px;
    }

    .svd-items {
        width: 100%;
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
    }

    .svd-item {
        flex: 1;
        box-sizing: border-box;
        height: 100px;
        padding: 5px;
        margin-bottom: 8px;
        background-color: #FFE2DE;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        width: calc((100% - 15px) / 3);
        min-width: calc((100% - 15px) / 3);
        max-width: calc((100% - 15px) / 3);
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
    }
    .svdname{
        font-size: 13px;
        height: 28px;
        line-height: 28px;
    }

</style>